import React from "react";

import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { getActivityHistoryCellStyle, isCellError } from "@common/components/ShakeTable/ui/activityHistory/DomainCell";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { LogType } from "@common/models/eventTracking";
import { CellContext } from "@tanstack/react-table";

interface TimeCellProps {
  // eslint-disable-next-line
  info: CellContext<LogUnionRowItem, any>;
}

const TimeCell = ({ info }: TimeCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {info.row.original.instance_type === LogType.NETWORK_REQUEST
        ? `${Math.round(info.row.original.duration)} ms`
        : ""}
    </BaseCell>
  );
};

export { TimeCell };
